import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import apiClient from '@/lib/api/apiClient';
import useSnackbar from '@/hooks/useSnackbar';
import { GetCadastreByReferenceResponse } from '@inversor-hub/types';

export const CADASTRE_LOOKUP_KEY = 'cadastre-lookup';

export function useLookupCadastre() {
  const { show: showSnackbar } = useSnackbar();

  return useMutation({
    mutationKey: [CADASTRE_LOOKUP_KEY],
    mutationFn: async (reference: string) => {
      const { data } = await apiClient.get<GetCadastreByReferenceResponse>(
        `/cadastre?reference=${encodeURIComponent(reference)}`
      );
      return data.data;
    },
    onError: (error: unknown) => {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.error || 'No se pudo obtener la informacion. Intentalo de nuevo.'
          : 'No se pudo obtener la informacion. Intentalo de nuevo.';

      showSnackbar({
        title: 'Error al consultar el catastro',
        message,
        variant: 'error',
      });
    },
  });
}
